import React, { useEffect, useState, useMemo } from "react"
import PropTypes from "prop-types"
import { Link, useNavigate, Redirect } from "react-router-dom"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons"

import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Input,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Form,
  InputGroup,
  InputGroupText,
  FormGroup,
  Label,
  UncontrolledTooltip,
  Modal,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap"
import Select from "react-select"
import classnames from "classnames"
import { connect } from "react-redux"
import withRouter from "components/Common/withRouter"

import {
  Pdate,
  Type,
  Value,
  ValueinUSD,
  Status,
  Coin,
  Tracked,
} from "./userstabledata"

import TableContainer from "../../components/Common/TableContainer"

// import img2 from "../../assets/images/no-time-off.59f54e64.svg"

//Date Picker
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import "assets/scss/datatables.scss"

// import { cryptoOrderData } from "../../../common/data";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import { getCryptoOrders } from "store/crypto/actions"

import toastr from "toastr"
import "toastr/build/toastr.min.css"
import { post } from "helpers/api_helper"
import axios from "axios"
import DeleteModal from "components/Common/DeleteModal"
import apiURl from "url"

const EcsUsers = props => {
  // Meta title
  document.title = "ECS Users"
  const navigate = useNavigate()

  // Authorization check
  const role_ = localStorage.getItem("role")
  if (role_ !== "admin") {
    navigate("/")
  }

  // State management
  const [showPassword, setShowPassword] = useState(false)
  const [showFPassword, setShowFPassword] = useState(false)
  const [orders, setOrders] = useState([])
  const [accountModal, setAccountModal] = useState(false)
  const [deleteModal, setDeleteModal] = useState(false)
  const [del_id, setDel_id] = useState(null)
  
  // Form state
  const [formData, setFormData] = useState({
    fullname: "",
    email: "",
    city: "",
    password: "",
    fpassword: "",
    role: "",
    userCode: "",
    assignedUsers: []
  })
  
  const [editID, setEditID] = useState(null)
  const [availableUsers, setAvailableUsers] = useState([])

  // Toggle password visibility
  const togglePasswordVisibility = (field) => {
    if (field === 'password') {
      setShowPassword(!showPassword)
    } else {
      setShowFPassword(!showFPassword)
    }
  }

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
    
    // Reset assignedUsers when role changes from sub-admin
    if (name === 'role' && value !== 'sub-admin') {
      setFormData(prev => ({
        ...prev,
        assignedUsers: []
      }))
    }
  }

  // Handle multi-select changes
  const handleMultiSelectChange = (selectedOptions) => {
    setFormData(prev => ({
      ...prev,
      assignedUsers: selectedOptions.map(option => option.value)
    }))
  }

  // Form validation
  const validateForm = () => {
    if (!formData.fullname) {
      toastr.error("Full Name is Required")
      return false
    }
    if (!formData.email) {
      toastr.error("Email is Required")
      return false
    }
    if (!formData.city) {
      toastr.error("City is Required")
      return false
    }
    if (!formData.password || formData.password !== formData.fpassword) {
      toastr.error("Passwords do not match")
      return false
    }
    if (!formData.role) {
      toastr.error("Role is Required")
      return false
    }
    if (!formData.userCode && !editID) { // Only require code for new users
      toastr.error("User Code is Required")
      return false
    }
    if (formData.role === 'sub-admin' && formData.assignedUsers.length === 0) {
      toastr.error("Please assign at least one user to sub-admin")
      return false
    }
    return true
  }

  // Handle form submission (create)
  const handleSubmit = async (e) => {
    e.preventDefault()
    
    if (!validateForm()) return
    
    try {
      const userData = {
        ...formData,
        assignedUsers: formData.role === 'sub-admin' ? formData.assignedUsers : []
      }
      
      const URL = `${apiURl}/addUser`
      const response = await axios.post(URL, userData)
      
      if (response.data.status === "success") {
        toastr.success("User added successfully")
        resetForm()
        fetchUsers()
      } else {
        toastr.error(response.data.message || "Failed to create user")
      }
    } catch (error) {
      handleApiError(error, "create user")
    }
  }

  // Handle user edit
  const handleEditUser = async (e) => {
    e.preventDefault()
    
    if (!validateForm()) return
    
    try {
      const userData = {
        edit_id: editID,
        ...formData,
        assignedUsers: formData.role === 'sub-admin' ? formData.assignedUsers : []
      }
      
      const URL = `${apiURl}/EditUser`
      const response = await axios.post(URL, userData)
      
      if (response.data.status === "success") {
        toastr.success("User updated successfully")
        resetForm()
        fetchUsers()
      } else {
        toastr.error(response.data.message || "Failed to update user")
      }
    } catch (error) {
      handleApiError(error, "update user")
    }
  }

  // Handle API errors
  const handleApiError = (error, action) => {
    if (error.response) {
      toastr.error(error.response.data.message || `Failed to ${action}`)
    } else if (error.request) {
      toastr.error(`Failed to ${action}. No response received from server.`)
    } else {
      toastr.error(`Failed to ${action}. Error in request setup.`)
    }
  }

  // Reset form
  const resetForm = () => {
    setFormData({
      fullname: "",
      email: "",
      city: "",
      password: "",
      fpassword: "",
      role: "",
      userCode: "",
      assignedUsers: []
    })
    setEditID(null)
    setAccountModal(false)
  }

  // Fetch users data
  const fetchUsers = async () => {
    try {
      const URL = `${apiURl}/fetchUsers`
      const response = await axios.get(URL)
      
      if (response.data.status === "success") {
        setOrders(response.data.users)
        // Prepare available users for sub-admin assignment (excluding admins and other sub-admins)
        setAvailableUsers(
          response.data.users
            .filter(user => !['admin', 'sub-admin','rider'].includes(user.role_))
            .map(user => ({
              value: user.id,
              label: `${user.full_name} (${user.role_})`
            }))
        )
      } else {
        console.error("Failed to fetch users:", response.data.message)
      }
    } catch (error) {
      console.error("Error fetching users:", error)
    }
  }

  // Fetch user data by ID for editing
  const fetchUserDataByID = async (id) => {
    try {
      const URL = `${apiURl}/fetchUserByID`
      const response = await axios.post(URL, { id })
      
      if (response.data.status === "success") {
        const userData = response.data.UserDataByID[0]
        if (userData) {
          setFormData({
            fullname: userData.full_name || "",
            email: userData.email_ || "",
            city: userData.city_ || "",
            password: userData.password_ || "",
            fpassword: userData.password_ || "",
            role: userData.role_ || "",
            userCode: userData.user_id || "",
            assignedUsers: userData.assigned_users ? JSON.parse(userData.assigned_users) : []
          })
          setEditID(userData.id || id)
          setAccountModal(true)
        }
      }
    } catch (error) {
      console.error("Error fetching user data:", error)
    }
  }

  // Delete user
  const deleteUser = (id) => {
    setDeleteModal(true)
    setDel_id(id)
  }

  const handleDeleteUser = async () => {
    try {
      const URL = `${apiURl}/deleteUser`
      const response = await axios.post(URL, { id: del_id })
      
      if (response.data.status === "success") {
        toastr.success("User deleted successfully")
        setDeleteModal(false)
        fetchUsers()
      } else {
        toastr.error(response.data.message || "Failed to delete user")
      }
    } catch (error) {
      console.error("Error deleting user:", error)
      toastr.error("Failed to delete user")
    } finally {
      setDeleteModal(false)
    }
  }

  // Initialize component
  useEffect(() => {
    fetchUsers()
  }, [])

  // Table columns
  const columns = useMemo(
    () => [
      {
        Header: "Code",
        accessor: "user_id",
        Cell: cellProps => <span>{cellProps.value}</span>
      },
      {
        Header: "Full Name",
        accessor: "full_name",
        Cell: cellProps => <span>{cellProps.value}</span>
      },
      {
        Header: "Email",
        accessor: "email_",
        Cell: cellProps => <span>{cellProps.value}</span>
      },
      {
        Header: "City",
        accessor: "city_",
        Cell: cellProps => <span>{cellProps.value}</span>
      },
      {
        Header: "Role",
        accessor: "role_",
        Cell: cellProps => {
          const role = cellProps.value
          let badgeClass = "bg-secondary"
          if (role === "admin") badgeClass = "bg-danger"
          if (role === "sub-admin") badgeClass = "bg-warning"
          if (role === "employee") badgeClass = "bg-primary"
          
          return <span className={`badge ${badgeClass}`}>{role}</span>
        }
      },
      {
        Header: "Assigned Users",
        accessor: "assigned_users",
        Cell: cellProps => {
          if (cellProps.row.original.role_ !== 'sub-admin') return '-'
          const assigned = JSON.parse(cellProps.value || '[]')
          return assigned.length > 0 
            ? `${assigned.length} users` 
            : 'None'
        }
      },
      {
        Header: "Action",
        accessor: "id",
        Cell: cellProps => (
          <div className="d-flex gap-3">
            <Link
              to="#"
              onClick={() => fetchUserDataByID(cellProps.value)}
              className="text-primary"
            >
              <i className="mdi mdi-eye font-size-18" id="viewtooltip" />
              <UncontrolledTooltip placement="top" target="viewtooltip">
                View
              </UncontrolledTooltip>
            </Link>
            <Link
              to="#"
              className="text-danger"
              onClick={() => deleteUser(cellProps.value)}
            >
              <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
              <UncontrolledTooltip placement="top" target="deletetooltip">
                Delete
              </UncontrolledTooltip>
            </Link>
          </div>
        )
      }
    ],
    []
  )

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
      />
      
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xl="6">
              <h5 className="mt-2">Users Management</h5>
            </Col>
            <Col>
              <div className="float-end">
                <Button
                  color="primary"
                  className="btn-sm w-md"
                  onClick={() => setAccountModal(true)}
                >
                  <i className="fa fa-fw fa-plus me-1" />
                  Create User
                </Button>
              </div>
            </Col>
          </Row>

          <Row className="pt-3">
            <Col lg="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={orders}
                    customPageSize={10}
                    className="custom-table"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* User Modal */}
      <Modal
        isOpen={accountModal}
        toggle={() => setAccountModal(!accountModal)}
        size="lg"
        centered
      >
        <Form onSubmit={editID ? handleEditUser : handleSubmit}>
          <ModalHeader toggle={() => setAccountModal(!accountModal)}>
            {editID ? "Edit User" : "Create New User"}
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label>Full Name *</Label>
                  <Input
                    type="text"
                    name="fullname"
                    value={formData.fullname}
                    onChange={handleInputChange}
                    placeholder="Enter full name"
                    required
                  />
                </FormGroup>
                
                <FormGroup>
                  <Label>City *</Label>
                  <Input
                    type="text"
                    name="city"
                    value={formData.city}
                    onChange={handleInputChange}
                    placeholder="Enter city"
                    required
                  />
                </FormGroup>
                
                <FormGroup>
                  <Label>Password *</Label>
                  <InputGroup>
                    <Input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      value={formData.password}
                      onChange={handleInputChange}
                      placeholder="Enter password"
                      required
                    />
                    <InputGroupText
                      onClick={() => togglePasswordVisibility('password')}
                      style={{ cursor: "pointer" }}
                    >
                      <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                    </InputGroupText>
                  </InputGroup>
                </FormGroup>

                {!editID && (
                  <FormGroup>
                    <Label>User Code *</Label>
                    <Input
                      type="text"
                      name="userCode"
                      value={formData.userCode}
                      onChange={handleInputChange}
                      placeholder="Enter unique user code"
                      required
                    />
                  </FormGroup>
                )}
              </Col>
              
              <Col md={6}>
                <FormGroup>
                  <Label>Email *</Label>
                  <Input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Enter email"
                    required
                  />
                </FormGroup>
                
              
                <FormGroup>
                  <Label>Role *</Label>
                  <Input
                    type="select"
                    name="role"
                    value={formData.role}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select role...</option>
                    <option value="admin">Admin</option>
                    <option value="sub-admin">Sub-Admin</option>
                    <option value="employee">Employee</option>
                    <option value="franchises">Franchises</option>
                    <option value="rider">Rider</option>
                  </Input>
                </FormGroup>
                
                <FormGroup>
                  <Label>Confirm Password *</Label>
                  <InputGroup>
                    <Input
                      type={showFPassword ? "text" : "password"}
                      name="fpassword"
                      value={formData.fpassword}
                      onChange={handleInputChange}
                      placeholder="Confirm password"
                      required
                    />
                    <InputGroupText
                      onClick={() => togglePasswordVisibility('fpassword')}
                      style={{ cursor: "pointer" }}
                    >
                      <FontAwesomeIcon icon={showFPassword ? faEyeSlash : faEye} />
                    </InputGroupText>
                  </InputGroup>
                </FormGroup>
                
                {editID && formData.userCode && (
                  <FormGroup>
                  <Label>User Code *</Label>
                  <Input
                    type="text"
                    name="userCode"
                    value={formData.userCode}
                    onChange={handleInputChange}
                    placeholder="Enter unique user code"
                    required
                  />
                </FormGroup>
                )}
              </Col>
            </Row>
            
            {/* Sub-admin assignment section */}
            {formData.role === 'sub-admin' && (
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Label>Assign Users</Label>
                    <Select
                      isMulti
                      options={availableUsers}
                      value={availableUsers.filter(option => 
                        formData.assignedUsers.includes(option.value)
                        )}
                      onChange={handleMultiSelectChange}
                      placeholder="Select users to manage..."
                      className="react-select"
                      classNamePrefix="select"
                    />
                    <small className="text-muted">
                      Select users this sub-admin will have access to manage
                    </small>
                  </FormGroup>
                </Col>
              </Row>
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={resetForm}>
              Cancel
            </Button>
            <Button color="primary" type="submit">
              {editID ? "Update User" : "Create User"}
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </React.Fragment>
  )
}

export default EcsUsers
